import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

import { getHub } from '../../../api';
import LineItem from '../../../components/LineItem';
import MapHubLocationSelector from '../../../components/HubForm/MapHubLocationSelector';

/**
 * A hub's details and where it sits on the floor plan, for the View dialog.
 * The server has no route to edit a hub, so there is nothing to save here.
 */
export default function HubDetails({ serialNumber }) {
  const [hub, setHub] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    getHub(serialNumber)
      .then((h) => live && setHub(h))
      .catch((e) => live && setError(typeof e === 'string' ? e : 'Unable to retrieve this hub.'));
    return () => {
      live = false;
    };
  }, [serialNumber]);

  if (error) return <div style={{ padding: '16px 0' }}>{error}</div>;
  if (hub == null) return <div style={{ padding: '16px 0' }}><CircularProgress size={24} /></div>;

  return (
    <div style={{ paddingTop: 8 }}>
      <LineItem description='Serial number' value={hub.getSerialNumber()} mono />
      <LineItem description='Hub type' value={hub.getHubType()} />
      <LineItem description='Room' value={hub.getRoom()?.getIdentifier()} />
      <LineItem description='Firmware' value={hub.getFirmwareVersion()} mono />
      <LineItem description='Notes' value={hub.getNotes()} last />
      {hub.getRoom()?.getFloor()?.getFloorPlanImage() &&
        <div style={{ marginTop: 16 }}>
          <MapHubLocationSelector
            x={hub.getCoordinate()?.getX()}
            y={hub.getCoordinate()?.getY()}
            floorPlanImagePath={hub.getRoom()?.getFloor()?.getFloorPlanImage()}
          />
        </div>}
    </div>
  );
}

HubDetails.propTypes = {
  serialNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
